import { NotificationController } from 'core-components/library/popup'
import { IWSClient } from 'core/classes/ws/IWSClient'
import { wsConnectionPool } from 'core/classes/ws/WSConnectionPool'

import { IIssue } from '../models/IIssueModel'

export const createIssue = async (issue: IIssue) => {
  const wsJira = await wsConnectionPool.getAuthorizedClient('jira-facade')
  try {
    const res = await wsJira?.call('debugger', 'createDocument', {
      issue,
    })
    if (res.status === 'error') {
      throw new Error(res.message)
    }
    await processIssueNotifications({
      issue: { ...res.data.document, EntryId: res.data.document.id },
      oldIssue: null,
      wsJira,
    })
    return true
  } catch (err) {
    const message =
      (err as Error)?.message || (typeof err === 'string' ? err : 'Something went wrong')
    NotificationController.showError({ message })
    console.error(err)
  }
  return false
}

const processIssueNotifications = async ({
  issue,
  oldIssue,
  wsJira,
}: {
  issue: IIssue
  oldIssue: IIssue | null
  wsJira: IWSClient | null
}) => {
  await wsJira?.call('debugger', 'processIssueNotifications', { issue, oldIssue }, true)
}
